import { render, staticRenderFns } from "./DdLoginButton.vue?vue&type=template&id=3828f27e&scoped=true&"
import script from "./DdLoginButton.vue?vue&type=script&lang=js&"
export * from "./DdLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./DdLoginButton.vue?vue&type=style&index=0&id=3828f27e&scoped=true&lang=css&"
import style1 from "./DdLoginButton.vue?vue&type=style&index=1&id=3828f27e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828f27e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
